import { ACTIONS } from '../constants/event-types';

const INITIAL_STATE = {
  typesList: {
    types: [],
    params: {},
    pager: null,
    loading: false,
    error: null,
  },
  activeType: { type: null, loading: false, error: null },
};

export const eventTypes = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    /* ---------- LIST ---------- */
    case ACTIONS.EVENT_TYPES_FETCH_START:
      return {
        ...state,
        typesList: {
          ...state.typesList,
          loading: true,
          error: null,
          params: action.payload || {},
        },
      };

    case ACTIONS.EVENT_TYPES_FETCH_SUCCESS:
      return {
        ...state,
        typesList: {
          ...state.typesList,
          types: action.payload.results,
          pager: action.payload.paginator,
          loading: false,
          error: null,
        },
      };

    case ACTIONS.EVENT_TYPES_FETCH_FAILURE:
      return {
        ...state,
        typesList: { ...state.typesList, loading: false, error: action.payload },
      };

    /* ---------- SINGLE FETCH ---------- */
    case ACTIONS.EVENT_TYPE_FETCH_START:
      return {
        ...state,
        activeType: { type: null, loading: true, error: null },
      };

    case ACTIONS.EVENT_TYPE_FETCH_SUCCESS:
      return {
        ...state,
        activeType: { type: action.payload, loading: false, error: null },
      };

    case ACTIONS.EVENT_TYPE_FETCH_FAILURE:
      return {
        ...state,
        activeType: { type: null, loading: false, error: action.payload },
      };

    /* ---------- CREATE ---------- */
    case ACTIONS.EVENT_TYPE_CREATE_SUCCESS:
      return {
        ...state,
        typesList: {
          ...state.typesList,
          types: [...state.typesList.types, action.payload],
        },
        activeType: { type: action.payload, loading: false, error: null },
      };

    /* ---------- UPDATE ---------- */
    case ACTIONS.EVENT_TYPE_UPDATE_SUCCESS:
      return {
        ...state,
        typesList: {
          ...state.typesList,
          types: state.typesList.types.map(t => (t.id === action.payload.id ? action.payload : t)),
        },
        activeType: { type: action.payload, loading: false, error: null },
      };

    /* ---------- DELETE ---------- */
    case ACTIONS.EVENT_TYPE_DELETE_SUCCESS:
      return {
        ...state,
        typesList: {
          ...state.typesList,
          types: state.typesList.types.filter(t => t.id !== action.payload.id),
        },
        activeType: { type: null, loading: false, error: null },
      };

    /* ---------- FAILURES ---------- */
    case ACTIONS.EVENT_TYPE_CREATE_FAILURE:
    case ACTIONS.EVENT_TYPE_UPDATE_FAILURE:
    case ACTIONS.EVENT_TYPE_DELETE_FAILURE:
      return {
        ...state,
        activeType: { ...state.activeType, loading: false, error: action.payload },
      };

    /* ---------- RESET ---------- */
    case ACTIONS.EVENT_TYPE_RESET:
      return {
        ...state,
        activeType: { type: null, loading: false, error: null },
      };

    default:
      return state;
  }
};
